<template>
  <div class="offers-column offers-column_positions d-contents">
    <div class="offers-table-cell offers-table-cell_sticky offers-table-cell_navigation spacex-8">
      <button class="offers-navigation-btn" @click="handleScroll(false)">
        <ChevronIcon />
      </button>
      <button class="offers-navigation-btn offers-navigation-btn_right" @click="handleScroll">
        <ChevronIcon />
      </button>
    </div>
    <div class="offers-table-cell offers-table-cell_sticky" :style="{ 'grid-row': '2 / 3' }">
      {{ $t('Description') }}
    </div>
    <div class="offers-table-cell offers-table-cell_sticky" :style="{ 'grid-row': '3 / 4' }">
      {{ $t('Files') }}
    </div>
    <div
      v-for="(value, idx) in tenderOffers.lists"
      :key="value.id"
      class="offers-table-cell offers-table-cell_sticky"
      :style="{ 'grid-row': `${idx + 4} / ${idx + 5}` }"
    >
      {{ value.title }}
    </div>
    <div
      class="offers-table-cell offers-table-cell_sticky"
      :style="{ 'grid-row': `${listsCount + 4} / ${listsCount + 5}` }"
    >
      {{ $t('Taxes') }}
    </div>
  </div>
</template>

<script>
  import ChevronIcon from '@/assets/icons/chevron.svg';

  export default {
    name: 'IncomingOffersLegend',
    components: {
      ChevronIcon,
    },
    props: {
      tenderOffers: {
        type: Object,
        required: true,
      },
    },
    computed: {
      listsCount() {
        return this.tenderOffers?.lists?.length || 0;
      },
    },
    methods: {
      handleScroll(right = true) {
        let scrollBar = document.querySelector('#tender-summary-content');
        scrollBar.scrollLeft = right ? scrollBar.scrollLeft + 180 : scrollBar.scrollLeft - 180;
      },
    },
  };
</script>
